import React from "react"
import styled from "styled-components"

import { Section, Container } from "../global"

const CARDS = [
  {
    emoji: "🔥",
    title: "Cheers & reactions",
    text: "Long-press any day and pick your emoji. Someone cheered you? Cheer them back with one tap.",
  },
  {
    emoji: "💬",
    title: "Notes from the community",
    text: "Anonymous, real notes from real days. Little windows into other people showing up — no names, ever.",
  },
  {
    emoji: "🤝",
    title: "Sun buddies",
    text: "The people who show up for you, day after day. Your streak has a cheering section.",
  },
  {
    emoji: "🏆",
    title: "Weekly highlights",
    text: "Every week, the community's wins get celebrated — big streaks, comebacks, and golden suns.",
  },
]

const Community = () => (
  <StyledSection id="community">
    <StyledContainer>
      <Subtitle>The community</Subtitle>
      <SectionTitle>You don't do this alone</SectionTitle>
      <LeadText>
        Every sun you put up is seen. Day is full of people working on their own
        perfect days — and cheering on yours.
      </LeadText>
      <CardsGrid>
        {CARDS.map((card) => (
          <Card key={card.title}>
            <CardEmoji>{card.emoji}</CardEmoji>
            <CardTitle>{card.title}</CardTitle>
            <CardText>{card.text}</CardText>
          </Card>
        ))}
      </CardsGrid>
    </StyledContainer>
  </StyledSection>
)

export default Community

const StyledSection = styled(Section)`
  background: linear-gradient(180deg, #fffdf8 0%, #fff4e3 100%);
`

const StyledContainer = styled(Container)``

const SectionTitle = styled.h3`
  color: ${(props) => props.theme.color.primary};
  display: flex;
  justify-content: center;
  margin: 0 auto 16px;
  text-align: center;
`

const Subtitle = styled.h5`
  font-size: 16px;
  color: ${(props) => props.theme.color.accent};
  letter-spacing: 1px;
  text-transform: uppercase;
  margin-bottom: 12px;
  text-align: center;
`

const LeadText = styled.p`
  max-width: 560px;
  margin: 0 auto 48px;
  text-align: center;
  color: ${(props) => props.theme.color.black.light};
  font-size: 18px;
  line-height: 28px;
`

const CardsGrid = styled.div`
  max-width: 900px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin: 0 auto;
  grid-column-gap: 32px;
  grid-row-gap: 32px;
  @media (max-width: ${(props) => props.theme.screen.sm}) {
    grid-template-columns: 1fr;
    padding: 0 32px;
  }
`

const Card = styled.div`
  background: white;
  border: 1px solid #ffe9c7;
  border-radius: 20px;
  padding: 28px;
  box-shadow: 0 6px 20px rgba(219, 152, 64, 0.08);
  transition: transform 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 16px 32px rgba(219, 152, 64, 0.18);
  }
`

const CardEmoji = styled.div`
  font-size: 34px;
  margin-bottom: 12px;
`

const CardTitle = styled.h4`
  color: ${(props) => props.theme.color.primary};
  margin: 0 0 10px;
`

const CardText = styled.p`
  margin: 0;
  color: ${(props) => props.theme.color.black.light};
  line-height: 24px;
`
